import React from 'react';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';

const Toast = ({ open, message, onClose, autoHideDuration = 6000 }) => {
  return (
    <Snackbar
      open={open}
      autoHideDuration={autoHideDuration}
      onClose={onClose}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      sx={{
        '& .MuiSnackbar-root': {
          top: '24px',
          right: '24px',
        },
        '& .MuiPaper-root': {
          borderRadius: '8px',
        },
      }}
    >
      <MuiAlert
        elevation={6}
        variant="filled"
        icon={false} 
        onClose={onClose}
        sx={{
          width: '350px',
          borderRadius: '8px',
          backgroundColor: '#45667E', 
          color: '#ffffff',
          boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)',
          '& .MuiAlert-message': {
            padding: '8px 0',
            fontSize: '14px',
            fontWeight: 500,
            fontFamily:'Inter'
          },
          '& .MuiAlert-action': {
            paddingLeft: '16px',
            alignItems: 'flex-start',
          },
        }}
      >
        {message}
      </MuiAlert>
    </Snackbar>
  );
};

export default Toast;
